import {Component, h} from "preact";
import {ICON_CHECKBOX, ICON_CHECKBOX_CHECKED, ICON_CHEVRON} from "../../lib/icons";
import {classes} from "mojave/classes";


/**
 * @typedef {{
 *      steps: string[],
 *      activeStep: number,
 *      isDeactivated: boolean,
 *      onDirectSelect: function(number),
 * }} HorizontalNavigation.Props
 *
 * @typedef {{
 * }} HorizontalNavigation.State
 */
export class HorizontalNavigation extends Component
{
	/**
	 * @param {HorizontalNavigation.Props} props
	 * @param {HorizontalNavigation.State} state
	 * @returns {null|JSX.Element}
	 */
	render (props, state)
	{
		return (
			<div class="_membership-horizontal-navigation">
				{props.steps.map((label, index) => this.renderButton(label, index + 1))}
			</div>
		);
	}


	/**
	 * Renders a single button
	 *
	 * @private
	 * @param {string} label
	 * @param {number} stepNr
	 * @returns {JSX.Element}
	 */
	renderButton (label, stepNr)
	{
		/** @type {HorizontalNavigation.Props} props */
		const props = this.props;
		const isSelectable = !props.isDeactivated && (stepNr < props.activeStep);
		let icon;

		if (stepNr < props.activeStep)
		{
			icon = ICON_CHECKBOX_CHECKED;
		}
		else if (stepNr === props.activeStep)
		{
			icon = ICON_CHEVRON;
		}
		else
		{
			icon = ICON_CHECKBOX;
		}

		return (
			<button
				type="button"
				onClick={() => this.onClick(stepNr)}
				class={classes({
					"_membership-horizontal-step": true,
					"_membership-is-selectable": isSelectable,
				})}
			>
				<span class="_membership-horizontal-icon">{icon}</span>
				<span>{label}</span>
			</button>
		);
	}


	/**
	 * Callback on when a step was clicked
	 *
	 * @private
	 * @param {number} stepNr
	 */
	onClick (stepNr)
	{
		/** @type {HorizontalNavigation.Props} props */
		const props = this.props;

		if (!props.isDeactivated && stepNr < props.activeStep)
		{
			props.onDirectSelect(stepNr);
		}
	}
}
